import { render, staticRenderFns } from "./AddDoctor.vue?vue&type=template&id=040c5188&scoped=true"
import script from "./AddDoctor.vue?vue&type=script&lang=js"
export * from "./AddDoctor.vue?vue&type=script&lang=js"
import style0 from "./AddDoctor.vue?vue&type=style&index=0&id=040c5188&prod&lang=scss&scoped=true"
import style1 from "./AddDoctor.vue?vue&type=style&index=1&id=040c5188&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040c5188",
  null
  
)

export default component.exports